import ReactDOM from 'react-dom/client';

const krRelationsRoots = new Map<string, { root: ReactDOM.Root; mountEl: HTMLElement }>();

/**
 * The legacy hosts destroy and recreate the container under the same id, so a cached root is
 * only reusable while it is still bound to the element currently in the DOM.
 */
export function resolveKrRelationsRoot(domId: string, mountEl: HTMLElement): ReactDOM.Root {
  const existing = krRelationsRoots.get(domId);
  if (existing?.mountEl === mountEl) {
    return existing.root;
  }

  existing?.root.unmount();
  const root = ReactDOM.createRoot(mountEl);
  krRelationsRoots.set(domId, { root, mountEl });
  return root;
}
